import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">Product Directory</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              Popular Collections
            </h2>
            <p className="mt-3 text-foreground-600 text-sm max-w-xl">
              Every category redirects to kaspreadsheet.com — instant access to thousands of verified CSSBuy product finds across all major categories.
            </p>
          </div>
          <Link
            to="/article/cssbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl p-5 hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-200 transition-colors mb-3">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.count}</p>
              <span className="absolute top-4 right-4 text-foreground-300 group-hover:text-primary-400 transition-colors">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}